import { Contact, PhoneNumber } from '@lgg/isomorphic/types/__generated__/graphql';
import { useAuthorization } from 'src/hooks/use-authorization';

export const usePhoneNumberValidationUtils = () => {
  const { getFeatureFlag } = useAuthorization();

  const supportedRegionsCallsPhoneNumbers =
    getFeatureFlag('channel_calls_valid_countries') ?? [];
  const supportedRegionsSmsPhoneNumbers =
    getFeatureFlag('channel_sms_valid_countries') ?? [];

  const isPhoneNumberRegionSupportedForCalls = (
    phoneNumber: PhoneNumber | null | undefined,
  ) => {
    if (!phoneNumber) {
      return false;
    }

    return supportedRegionsCallsPhoneNumbers.includes(phoneNumber.regionCode);
  };

  const isPhoneNumberRegionSupportedForSms = (
    phoneNumber: PhoneNumber | null | undefined,
  ) => {
    if (!phoneNumber) {
      return false;
    }

    return supportedRegionsSmsPhoneNumbers.includes(phoneNumber.regionCode);
  };

  const hasValidCallNumbers = (contact?: Contact | null) => {
    if (!contact) {
      return false;
    }

    const primaryPhone = contact.primaryPhone;
    const secondaryPhone = contact.secondaryPhone;

    const hasValidPrimary =
      primaryPhone && supportedRegionsCallsPhoneNumbers.includes(primaryPhone.regionCode);
    const hasValidSecondary =
      secondaryPhone &&
      supportedRegionsCallsPhoneNumbers.includes(secondaryPhone.regionCode);

    return hasValidPrimary || hasValidSecondary || false;
  };

  const hasOnlyUnsupportedRegionCallNumbers = (contact?: Contact | null) => {
    if (!contact) {
      return false;
    }

    const primaryPhone = contact.primaryPhone;
    const secondaryPhone = contact.secondaryPhone;

    if (!primaryPhone && !secondaryPhone) {
      return false;
    }

    const isPrimarySupportedRegion = primaryPhone
      ? isPhoneNumberRegionSupportedForCalls(primaryPhone)
      : false;
    const isSecondarySupportedRegion = secondaryPhone
      ? isPhoneNumberRegionSupportedForCalls(secondaryPhone)
      : false;

    return !isPrimarySupportedRegion && !isSecondarySupportedRegion;
  };

  return {
    isPhoneNumberRegionSupportedForCalls,
    isPhoneNumberRegionSupportedForSms,
    hasValidCallNumbers,
    hasOnlyUnsupportedRegionCallNumbers,
  };
};

export const normalizePhoneNumberForId = (phoneNumber: string) => {
  return phoneNumber.replace('+', '');
};
